import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import Breadcrumb from "../components/Breadcrumb";
import WishlistSection from "../components/WishlistSection";
import Shipping from "../components/Shipping";
import ScrollToTop from "react-scroll-to-top";

const WishlistPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb */}
      <Breadcrumb title={"Wishlist"} />

      {/* WishlistSection */}
      <WishlistSection />

      {/* Shipping */}
      <Shipping />
    </>
  );
};

export default WishlistPage;

